import React from "react";
import ReactGA from "react-ga4";
import { NavLink } from "react-router-dom";
import commonClasses from "../ArticleStyle.css"
import classes from "./modbus-feature.css"
import FatArrow from "../../../containers/UI/FatArrow.svg"

const News = (props) => {

  return (
    <>
      <div className={commonClasses.container}>

        <div className={commonClasses.innerContainer}>
          <h3 className={commonClasses.dateLabel}>Tervuren, March 7th 2025</h3>
          <h1>Introducing Modbus on the Allorado Gateway</h1>
          
          <div className={classes.iframeContainer}><iframe className={classes.videoFrame} width="620" height="340" src={"https://www.youtube.com/embed/hGkWgK7rN6Q"} allowFullScreen title="LoRa to Modbus in one minute"></iframe></div>

          <p className={commonClasses.contentParagraph}>Allorado expands its innovation lineup with the new LoRa to Modbus mapper. This powerful addition enables seamless integration between LoRa-enabled devices and Modbus-based systems, unlocking new possibilities for industrial and building automation — especially in scenarios where cabling is difficult or impossible.</p>
          <p className={commonClasses.contentParagraph}>Experience the simplicity of bridging LoRa with Modbus by watching the two-minute demo video above and see how effortlessly an Allorado Gateway can extend your installations.</p>
          
          <div className={commonClasses.callToAction}>
            <h3>Ready to transform your factory?</h3>
            <div className={commonClasses.orderRow}>
              <NavLink className={commonClasses.orderButton} to={"/order"} onClick={() => ReactGA.event({ category: "Button", action: "News item to order" })}>Order your Allorado today</NavLink>
              <img src={FatArrow} className={commonClasses.arrow} alt="arrow"/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default News;
